import React from "react";
import { DISEASES, OTHER_DISEASE } from "../../constants/diseases";

/**
 * Maladie picker: a fixed list, plus a free-text detail field that appears only
 * when "Autre" is chosen.
 *
 * The four disease forms (mobile and desktop, create and update) share this so
 * the list cannot drift between them.
 */
function DiseaseSelect({
  value,
  otherValue,
  onChange,
  onOtherChange,
  inputClassName,
  labelClassName,
}) {
  return (
    <>
      <label htmlFor="cause_input" className={labelClassName}>
        Maladie
      </label>
      <select
        className={inputClassName}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        name="cause_input"
      >
        <option value="" disabled>
          Choisir une maladie
        </option>
        {DISEASES.map((disease) => (
          <option key={disease} value={disease}>
            {disease}
          </option>
        ))}
      </select>

      {value === OTHER_DISEASE && (
        <>
          <label htmlFor="cause_other_input" className={labelClassName}>
            Préciser
          </label>
          <input
            className={inputClassName}
            type="text"
            value={otherValue || ""}
            onChange={(e) => onOtherChange(e.target.value)}
            placeholder="Nom de la maladie"
            name="cause_other_input"
          />
        </>
      )}
    </>
  );
}

export default DiseaseSelect;
